// extracted by mini-css-extract-plugin
export var addToCartButton = "_o9-b";
export var arrowButtonContainer = "_o9-9";
export var arrowButtonIcon = "_o9-a";
export var carouselArrowButton = "_o9-6";
export var carouselElementContainer = "_o9-1";
export var left = "_o9-7";
export var productDisplayCarouselContainer = "_o9-0";
export var productTileContainer = "_o9-2";
export var productTileImage = "_o9-4";
export var productTileImageContainer = "_o9-3";
export var productTileTitle = "_o9-5";
export var right = "_o9-8";
export var sliderOverflow = "_o9-c";